/**
 * Copyright (c) 2026, CheckPlus Limited
 */

import { isValidPhoneNumber } from "react-phone-number-input";

import { checkEmail, isEmpty } from "./common.js";
import errorMsg from "../json/errMsg.json";

export const validDonorInfo = (donorData, language) => {
  let errObj = [];
  if (!language) {
    errObj.push("No Language");
  } else if (!donorData) {
    errObj.push("No Data");
  } else {
    const errMsgsObj = errorMsg[language].donorInfoErr;
    if (!checkEmail(donorData.username)) {
      errObj.push(errMsgsObj.username);
    }

    if (isEmpty(donorData.lastName)) {
      errObj.push(errMsgsObj.lastName);
    }

    if (isEmpty(donorData.firstName)) {
      errObj.push(errMsgsObj.firstName);
    }

    if (!isValidPhoneNumber(donorData.phoneNumber)) {
      errObj.push(errMsgsObj.phoneNumber);
    }
  }
  let boolean = true;
  if (errObj.length > 0) {
    boolean = false;
  }
  return {
    isValid: boolean,
    msgs: errObj,
  };
};

export const validSignupDonor = (donorData, language) => {
  let errObj = [];
  const errMsgsObj = errorMsg[language].donorInfoErr;

  if (!language) {
    errObj.push("No Language");
  } else if (!donorData) {
    errObj.push("No Data");
  } else {
    if (donorData.password !== donorData.confirmPassword) {
      errObj.push(errorMsg[language].infoSettingErr.loginConfirmPasswdErr);
    }

    if (isEmpty(donorData.lastName)) {
      errObj.push(errMsgsObj.lastName);
    }

    if (isEmpty(donorData.firstName)) {
      errObj.push(errMsgsObj.firstName);
    }

    if (!isValidPhoneNumber(donorData.phoneNumber)) {
      errObj.push(errMsgsObj.phoneNumber);
    }

    if (!checkEmail(donorData.username)) {
      errObj.push(errMsgsObj.username);
    }
  }

  let boolean = true;
  if (errObj.length > 0) {
    boolean = false;
  }
  return {
    isValid: boolean,
    msgs: errObj,
  };
};

export const validLoginEmailDonor = (donorData, language) => {
  let errObj = [];
  const errMsgsObj = errorMsg[language].donorInfoErr;

  if (!language) {
    errObj.push("No Language");
  } else if (!donorData) {
    errObj.push("No Data");
  } else {
    if (!checkEmail(donorData.username)) {
      errObj.push(errMsgsObj.username);
    }
  }

  let boolean = true;
  if (errObj.length > 0) {
    boolean = false;
  }
  return {
    isValid: boolean,
    msgs: errObj,
  };
};

export const validPw = (pw, language) => {
  let errObj = [];
  const errMsgsObj = errorMsg[language].pwErr;

  if (!language) {
    errObj.push("No Language");
  } else if (!pw) {
    errObj.push("No Data");
  } else {
    if (!pw) {
      errObj.push(errMsgsObj.passwdErr);
    }
    if (pw.length < 8) {
      errObj.push(errMsgsObj.newPasswdErr);
    }
  }

  let boolean = true;
  if (errObj.length > 0) {
    boolean = false;
  }
  return {
    isValid: boolean,
    msgs: errObj,
  };
};

export const validLoginDonor = (donorData, language) => {
  let errObj = [];
  if (!language) {
    errObj.push("No Language");
  } else if (!donorData) {
    errObj.push("No Data");
  } else {
    if (donorData.password.length < 8) {
      errObj.push(errorMsg[language].pwErr.newPasswdErr);
    }
    if (!checkEmail(donorData.username)) {
      errObj.push(errorMsg[language].donorInfoErr.username);
    }
  }

  let boolean = true;
  if (errObj.length > 0) {
    boolean = false;
  }
  return {
    isValid: boolean,
    msgs: errObj,
  };
};
